import type { FcAdminApiFailure } from '@shared/fcAdminApiTypes';

const errorMessages: Record<string, string> = {
    actor_not_linked: 'Das txAdmin-Konto ist noch nicht mit Discord verknüpft.',
    discord_not_linked: 'Das txAdmin-Konto ist noch nicht mit Discord verknüpft.',
    not_linked: 'Das txAdmin-Konto ist noch nicht mit Discord verknüpft.',
    discord_not_configured: 'Die Discord-Verbindung ist serverseitig noch nicht eingerichtet.',
    discord_credentials_rejected: 'Discord hat die Serveranmeldung abgelehnt. Die Verbindung muss administrativ erneuert werden.',
    discord_rate_limited: 'Discord begrenzt die Anfragen vorübergehend. Bitte nach der angezeigten Wartezeit erneut versuchen.',
    discord_invalid_response: 'Discord hat keine verwertbare Antwort geliefert. Bitte erneut versuchen.',
    discord_unavailable: 'Discord ist vorübergehend nicht erreichbar. Lesedaten können weiterhin verfügbar sein.',
    no_fc_team_role: 'Dem verknüpften Discord-Konto fehlt eine freigegebene FC-Teamrolle.',
    not_member: 'Das verknüpfte Discord-Konto ist nicht auf dem FATE-Teamserver.',
    permissions_not_ready: 'Die FC-Rechtematrix wird noch geladen. Bitte kurz warten.',
    forbidden: 'Für diesen Bereich fehlt die erforderliche FC-Berechtigung.',
    forbidden_resource: 'Der zuständige FC-Dienst hat diese Aktion nicht freigegeben.',
    action_rejected: 'Die Aktion wurde fachlich abgelehnt.',
    rejected: 'Die Anfrage konnte nicht sicher abgeschlossen werden.',
    request_rejected: 'Die Anfrage konnte nicht sicher abgeschlossen werden.',
    rank_guard: 'Die Zielperson steht außerhalb deiner FC-Hierarchie.',
    authorization_changed: 'Die Berechtigung hat sich geändert. Bitte den Vorgang erneut öffnen.',
    authorized: 'FC-Actor autorisiert.',
    stale_authorized: 'Bestätigter Zugriff mit zwischengespeichertem Lesestand.',
    authorization_stale: 'Der bestätigte Zugriff ist abgelaufen. Bitte die FC-Autorisierung aktualisieren.',
    checking: 'Die FC-Autorisierung wird geprüft.',
    bridge_not_configured: 'Die FC-Verbindung ist serverseitig noch nicht eingerichtet.',
    offline_snapshot: 'FC Admin zeigt einen gespeicherten Offline-Lesestand.',
    bridge_timeout: 'Der Gameserver hat nicht rechtzeitig geantwortet.',
    bridge_shutdown: 'Die FC-Verbindung wird gerade beendet.',
    bridge_send_failed: 'Die Anfrage konnte nicht an den Gameserver gesendet werden.',
    broker_timeout: 'fc_admin hat nicht rechtzeitig geantwortet.',
    broker_unavailable: 'Die Anfrage konnte nicht an den Gameserver übergeben werden.',
    service_starting: 'FC Admin startet gerade. Bitte einen Moment warten.',
    network_error: 'Netzwerkfehler. Bitte Verbindung prüfen und erneut versuchen.',
    session_expired: 'Die Sitzung ist abgelaufen. Bitte erneut anmelden.',
    request_cancelled: 'Die Anfrage wurde abgebrochen, weil die Ansicht gewechselt oder geschlossen wurde.',
    invalid_response: 'Der zuständige FC-Dienst hat eine ungültige Antwort geliefert.',
    response_invalid: 'Der zuständige FC-Dienst hat eine ungültige Antwort geliefert.',
    resource_offline: 'Die Resource fc_admin ist derzeit nicht erreichbar.',
    offline: 'Der FC-Dienst ist derzeit nicht erreichbar.',
    gameserver_offline: 'Der Gameserver ist derzeit offline.',
    game_server_offline: 'Der Gameserver ist derzeit offline.',
    service_unavailable: 'Der zuständige FC-Dienst ist vorübergehend nicht erreichbar.',
    database_unavailable: 'Die FC-Datenbank ist vorübergehend nicht erreichbar.',
    rate_limited: 'Zu viele Anfragen. Bitte kurz warten und erneut versuchen.',
    stale_target: 'Die Spielersitzung hat sich geändert. Bitte die Akte neu laden.',
    target_changed: 'Das ausgewählte Ziel hat sich geändert. Bitte die Ansicht neu laden.',
    ticket_changed: 'Der Supportfall wurde zwischenzeitlich geändert. Bitte neu laden.',
    offline_reference_expired: 'Die Offline-Akte ist nicht mehr eindeutig referenzierbar. Bitte erneut suchen.',
    linked_session_missing: 'Für dieses Webkonto ist keine eindeutige Ingame-Sitzung verbunden.',
    linked_session_stale: 'Die verbundene Ingame-Sitzung hat sich geändert. Bitte erneut versuchen.',
    request_timeout: 'Die Anfrage hat ihr Zeitlimit erreicht. Bitte den aktuellen Stand prüfen.',
    expired: 'Die interne Anfrage ist abgelaufen. Bitte erneut versuchen.',
    expired_request: 'Die interne Anfrage ist abgelaufen. Bitte erneut versuchen.',
    duplicate_response: 'Die Antwort wurde bereits verarbeitet.',
    correlation_mismatch: 'Die Antwort konnte der Anfrage nicht sicher zugeordnet werden.',
    idempotency_conflict: 'Dieser Vorgang wurde bereits mit abweichenden Daten verwendet. Bitte die Ansicht neu öffnen.',
    idempotency_in_progress: 'Eine identische Aktion wird bereits verarbeitet.',
    idempotency_uncertain: 'Der Abschluss der vorherigen Aktion ist unklar. Bitte zuerst den aktuellen Stand prüfen.',
    reason_required: 'Eine Begründung mit mindestens drei Zeichen ist erforderlich.',
    invalid_vehicle: 'Das Fahrzeugmodell oder der Fahrzeugtyp ist nicht zulässig.',
    invalid_plate: 'Das Kennzeichen ist ungültig.',
    vehicle_not_found: 'Das Fahrzeug ist nicht mehr vorhanden.',
    vehicle_owner_mismatch: 'Das Fahrzeug gehört nicht mehr zur geöffneten Charakterakte.',
    owner_changed: 'Der Fahrzeugbesitz hat sich zwischenzeitlich geändert. Bitte die Akte neu laden.',
    occupied: 'Das Fahrzeug ist aktuell besetzt und wurde nicht entfernt.',
    cleanup_pending: 'Die Fahrzeugdaten wurden gelöscht, aber die Weltbereinigung ist noch nicht bestätigt. Bitte denselben Vorgang erneut versuchen.',
    no_impound: 'Für diesen Fahrzeugtyp ist kein Verwahrplatz verfügbar.',
    weight: 'Die Änderung überschreitet die verfügbare Inventarkapazität.',
    insufficient_items: 'Der vorhandene Itembestand reicht für diese Änderung nicht aus.',
    revision_conflict: 'Die Waffeninstanz wurde zwischenzeitlich geändert. Bitte die Akte neu laden.',
    weapon_mode_legacy: 'UID-Waffenänderungen sind im aktuellen Inventarmodus nicht verfügbar.',
    busy: 'Die Charakterakte wird bereits verändert. Bitte kurz warten und neu laden.',
    internal_error: 'FC Admin konnte die Anfrage nicht sicher abschließen.',
};

export const formatFcAdminError = (code?: string, fallback?: string) => {
    if (code) return errorMessages[code] ?? 'FC Admin konnte die Anfrage nicht abschließen.';
    return fallback || 'FC Admin konnte die Anfrage nicht abschließen.';
};

export const formatFcAdminFailure = (failure: Pick<FcAdminApiFailure, 'code' | 'message' | 'error' | 'retryable' | 'correlationId'>) => {
    const retry = failure.retryable ? 'erneut versuchbar' : 'nicht automatisch wiederholen';
    return `${formatFcAdminError(failure.code, failure.message || failure.error)} · ${failure.code} · ${retry} · ${failure.correlationId}`;
};

export const formatFcAdminNotice = (failure: Pick<FcAdminApiFailure, 'code' | 'message' | 'error'>) => (
    formatFcAdminError(failure.code, failure.message || failure.error)
);

const permissionFailures = new Set(['forbidden', 'forbidden_resource', 'rank_guard', 'no_fc_team_role']);
const timeoutFailures = new Set(['bridge_timeout', 'broker_timeout', 'request_timeout', 'expired', 'expired_request']);
const transportFailures = new Set(['bridge_shutdown', 'bridge_send_failed', 'broker_unavailable', 'resource_offline', 'offline', 'gameserver_offline', 'game_server_offline', 'service_unavailable', 'service_starting', 'network_error']);

export const formatFcQueueFailure = (
    failure: Pick<FcAdminApiFailure, 'code'>,
    area: 'Support' | 'Einreise',
) => {
    if (failure.code === 'action_rejected') {
        return `Die ${area === 'Support' ? 'Supportaktion' : 'Einreiseaktion'} wurde fachlich abgelehnt.`;
    }
    if (permissionFailures.has(failure.code)) return `Dir fehlt die Berechtigung für diese ${area}-Aktion.`;
    if (timeoutFailures.has(failure.code)) return `Der ${area}-Dienst hat nicht rechtzeitig geantwortet. Bitte den aktuellen Stand neu laden, bevor du die Aktion erneut ausführst.`;
    if (transportFailures.has(failure.code)) return `Die Verbindung zum ${area}-Dienst ist momentan unterbrochen. Die Aktion wurde nicht automatisch wiederholt.`;
    if (failure.code === 'invalid_response' || failure.code === 'response_invalid') return `Der ${area}-Dienst hat eine unvollständige Antwort geliefert. Bitte die Warteschlange neu laden.`;
    if (failure.code === 'authorization_changed') return `Deine Berechtigung hat sich während der ${area}-Anfrage geändert. Bitte die Ansicht neu laden.`;
    return `${area} konnte die Anfrage nicht sicher abschließen. Bitte die Warteschlange neu laden.`;
};

const retryableReadFailures = new Set([
    'rate_limited',
    'service_starting',
    'request_timeout',
    'network_error',
    'bridge_timeout',
    'broker_timeout',
    'discord_rate_limited',
]);
const unexecutedReadFailures = new Set(['rate_limited', 'service_starting', 'discord_rate_limited']);
const jobStartingReads = new Set(['audit.export']);
export const fcAdminReadRetryLimit = 2;
const readRetryFallbackMs = 1500;
const readRetryMinimumMs = 250;
const readRetryMaximumMs = 10_000;
const readRetryJitterMs = 250;

export const isRetryableFcAdminReadFailure = (failure?: Pick<FcAdminApiFailure, 'code'>) => (
    !!failure && retryableReadFailures.has(failure.code)
);

export const fcAdminReadRetryDelay = (
    operation: string,
    failure: Pick<FcAdminApiFailure, 'code' | 'retryAfterMs'>,
    attempt: number,
    random: () => number = Math.random,
) => {
    if (attempt >= fcAdminReadRetryLimit || !retryableReadFailures.has(failure.code)) return undefined;
    if (jobStartingReads.has(operation) && !unexecutedReadFailures.has(failure.code)) return undefined;
    const requested = typeof failure.retryAfterMs === 'number' && Number.isFinite(failure.retryAfterMs) && failure.retryAfterMs >= 0
        ? failure.retryAfterMs
        : readRetryFallbackMs;
    if (requested > readRetryMaximumMs) return undefined;
    return Math.max(readRetryMinimumMs, requested) + Math.floor(Math.min(Math.max(random(), 0), 1) * readRetryJitterMs);
};

export const fcAdminTransportFailure = (message?: string): FcAdminApiFailure => {
    const code = message === 'Session expired'
        ? 'session_expired'
        : message?.startsWith('Request timed out') ? 'request_timeout' : 'network_error';
    const text = formatFcAdminError(code);
    return {
        ok: false,
        error: text,
        code,
        message: text,
        retryable: code !== 'session_expired',
        correlationId: 'local-transport',
    };
};
